import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakePrecosProcessadosBondsTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "DataReferencia": dayjs().format(DATE_FORMAT),
            "ISIN": "N/A",
            "TaxaMTM": 0,
            "PUMTM_Limpo": 0,
            "PUMTM_Sujo": 0,
            "PercPUPAR_Limpo": 0,
            "PercPUPAR_Sujo": 0,
            "Duration": 0,
            "DurationAno": 0,
            "DataProximoCupom": dayjs().format(DATE_FORMAT),
            "CupomAccruado": 0
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, DataReferencia, ISIN, TaxaMTM, PUMTM_Limpo, PUMTM_Sujo, PercPUPAR_Limpo, PercPUPAR_Sujo, Duration, DurationAno, DataProximoCupom, CupomAccruado
        } = newRow

        const body = {
            "DataReferencia": dayjs(DataReferencia).format(DATE_FORMAT),
            "ISIN": ISIN,
            "TaxaMTM": TaxaMTM,
            "PUMTM_Limpo": PUMTM_Limpo,
            "PUMTM_Sujo": PUMTM_Sujo,
            "PercPUPAR_Limpo": PercPUPAR_Limpo,
            "PercPUPAR_Sujo": PercPUPAR_Sujo,
            "Duration": Duration,
            "DurationAno": DurationAno,
            "DataProximoCupom": DataProximoCupom,
            "CupomAccruado": CupomAccruado
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
        },
        {
            field: 'ISIN',
            headerName: 'ISIN',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            editable: true
        },
        {
            field: 'TaxaMTM',
            headerName: 'TaxaMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'PUMTM_Limpo',
            headerName: 'PUMTM_Limpo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'PUMTM_Sujo',
            headerName: 'PUMTM_Sujo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'PercPUPAR_Limpo',
            headerName: 'PercPUPAR_Limpo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'PercPUPAR_Sujo',
            headerName: 'PercPUPAR_Sujo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'Duration',
            headerName: 'Duration',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'DurationAno',
            headerName: 'DurationAno',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'DataProximoCupom',
            headerName: 'DataProximoCupom',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            editable: true,
        },
        {
            field: 'CupomAccruado',
            headerName: 'CupomAccruado',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            editable: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            editable: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterDatalakePrecosProcessadosBondsTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterDatalakePrecosProcessadosBondsTable